import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xxl-8"
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-100px symbol-fixed position-relative" }
const _hoisted_6 = {
  key: 0,
  src: "media/avatars/blank.png",
  alt: "image",
  class: "img-thumbnail"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_15 = { class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2" }
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_18 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_19 = { class: "d-flex flex-wrap" }
const _hoisted_20 = { class: "border border-gray-300 border-dashed rounded flex-grow-1 py-3 px-4 me-6 mb-3" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "fs-2 fw-bolder" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Баланс", -1)
const _hoisted_24 = { class: "border border-gray-300 border-dashed rounded flex-grow-1 py-3 px-4 me-6 mb-3" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "svg-icon svg-icon-3 svg-icon-success me-2" }
const _hoisted_27 = { class: "fs-2 fw-bolder" }
const _hoisted_28 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_29 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_30 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Основні параметри ")
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Канали ")
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Оплати ")
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Заявки ")
const _hoisted_39 = {
  key: 0,
  class: "badge badge-danger ms-1 fs-6 lh-1 py-1 px-2 d-flex flex-center"
}
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Налаштування ")
const _hoisted_42 = {
  key: 2,
  class: "card mb-5 mb-xxl-8"
}
const _hoisted_43 = { class: "card-body pt-9 pb-0" }
const _hoisted_44 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_45 = { class: "me-7 mb-4" }
const _hoisted_46 = { class: "symbol symbol-100px symbol-lg-100px symbol-fixed position-relative" }
const _hoisted_47 = {
  key: 0,
  src: "media/avatars/blank.png",
  alt: "image",
  class: "img-thumbnail"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = {
  key: 3,
  class: "bg-danger position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"
}
const _hoisted_50 = { class: "flex-grow-1" }
const _hoisted_51 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_52 = { class: "d-flex flex-column" }
const _hoisted_53 = { class: "d-flex align-items-center mb-2" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_56 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_57 = { class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2" }
const _hoisted_58 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_59 = { class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2" }
const _hoisted_60 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_61 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_62 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_63 = { class: "d-flex flex-wrap" }
const _hoisted_64 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded flex-grow-1 py-3 px-4 me-6 mb-3"
}
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = { class: "svg-icon svg-icon-3 svg-icon-success me-2" }
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, " дата відключення ", -1)
const _hoisted_69 = { class: "border border-gray-300 border-dashed rounded flex-grow-1 py-3 px-4 me-6 mb-3" }
const _hoisted_70 = { class: "d-flex align-items-center" }
const _hoisted_71 = { class: "fs-2 fw-bolder" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Баланс", -1)
const _hoisted_73 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded flex-grow-1 py-3 px-4 me-6 mb-3"
}
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = { class: "svg-icon svg-icon-3 svg-icon-success me-2" }
const _hoisted_76 = { class: "fs-2 fw-bolder" }
const _hoisted_77 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed m-4" }, null, -1)
const _hoisted_79 = { class: "d-flex flex-row overflow-auto align-items-center justify-content-center mb-5" }
const _hoisted_80 = { class: "d-flex flex-column" }
const _hoisted_81 = ["disabled", "data-kt-indicator"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-up" }),
  /*#__PURE__*/_createTextVNode("Підключити")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Будь ласка, чекайте ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_84 = [
  _hoisted_82,
  _hoisted_83
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_VueNumberAnimation = _resolveComponent("VueNumberAnimation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ExclamationNotice = _resolveComponent("ExclamationNotice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentUser && _ctx.currentUser.user && !_ctx.currentUser.user.is_disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.currentUser.settings.settings.avatar == null)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_ctx.currentUser.settings.settings.avatar != null)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.currentUser.settings.settings.avatar,
                          alt: "image",
                          class: "img-thumbnail"
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px", {
                                'bg-success': _ctx.currentUser.user.cash >= 0,
                                'bg-danger': _ctx.currentUser.user.cash < 0,
                              }])
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: "/settings",
                        class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentUser.user.address), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.currentUser.settings.settings.phone_confirmed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen023.svg" })
                        ]),
                        _createTextVNode(" платіжний код: " + _toDisplayString(_ctx.currentUser.settings.settings.payment_code), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["svg-icon svg-icon-3 me-2", {
                                            'svg-icon-success': _ctx.currentUser.user.cash >= 0,
                                            'svg-icon-warning': _ctx.currentUser.user.cash < 0,
                                          }])
                          }, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin010.svg" })
                          ], 2),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_VueNumberAnimation, {
                              ref: "cash_counter",
                              startAmount: 0,
                              endAmount: _ctx.currentUser.user.cash,
                              duration: 3,
                              suffix: " грн",
                              separator: ",",
                              decimalSeparator: ".",
                              decimals: 0,
                              autoinit: true
                            }, null, 8, ["endAmount"])
                          ])
                        ]),
                        _hoisted_23
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", _hoisted_26, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin010.svg" })
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_VueNumberAnimation, {
                              ref: "days_counter",
                              startAmount: 0,
                              endAmount: _ctx.currentUser.settings.tariff.fee,
                              duration: 3,
                              suffix: " грн",
                              separator: ",",
                              decimalSeparator: ".",
                              decimals: 0,
                              autoinit: true
                            }, null, 8, ["endAmount"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, " тариф: " + _toDisplayString(_ctx.currentUser.settings.tariff.description), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("ul", _hoisted_30, [
                _createElementVNode("li", _hoisted_31, [
                  _createVNode(_component_router_link, {
                    to: "/overview",
                    class: "nav-link text-active-primary me-6",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_33, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: "/channels",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_35, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: "/payments",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_37, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: "/requests",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38,
                      (_ctx.requestsData && _ctx.requestsData.active_request)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, "1"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_40, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: "/settings",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentUser && _ctx.currentUser.user && !_ctx.currentUser.user.is_disabled)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.currentUser && _ctx.currentUser.user && _ctx.currentUser.user.is_disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  (_ctx.currentUser.settings.settings.avatar == null)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                    : (_ctx.currentUser.settings.settings.avatar != null)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.currentUser.settings.settings.avatar,
                          alt: "image",
                          class: _normalizeClass(["img-thumbnail", {'border-danger': _ctx.currentUser.user.is_disabled}])
                        }, null, 10, _hoisted_48))
                      : _createCommentVNode("", true),
                  (!_ctx.currentUser.user.is_disabled)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px", {
                                'bg-success': _ctx.currentUser.user.cash >= 0,
                                'bg-danger': _ctx.currentUser.user.cash < 0,
                              }])
                      }, null, 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_49))
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_router_link, {
                        to: "/settings",
                        class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentUser.settings.settings.name), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.currentUser.settings.settings.phone_confirmed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                            _createElementVNode("span", _hoisted_55, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("span", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.currentUser.user.address), 1)
                      ]),
                      _createElementVNode("span", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen023.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.currentUser.settings.settings.payment_code), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      (_ctx.currentUser.user.disable_data)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("span", _hoisted_66, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen014.svg" })
                              ]),
                              _createElementVNode("div", {
                                class: "fs-2 fw-bolder",
                                innerHTML: _ctx.currentUser.user.disable_data.date
                              }, null, 8, _hoisted_67)
                            ]),
                            _hoisted_68
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["svg-icon svg-icon-3 me-2", {
                                            'svg-icon-success': _ctx.currentUser.user.cash >= 0,
                                            'svg-icon-warning': _ctx.currentUser.user.cash < 0,
                                          }])
                          }, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin010.svg" })
                          ], 2),
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_component_VueNumberAnimation, {
                              ref: "cash_counter",
                              startAmount: 0,
                              endAmount: _ctx.currentUser.user.cash,
                              duration: 3,
                              suffix: " грн",
                              separator: ",",
                              decimalSeparator: ".",
                              decimals: 0,
                              autoinit: true
                            }, null, 8, ["endAmount"])
                          ])
                        ]),
                        _hoisted_72
                      ]),
                      (_ctx.currentUser.user.disable_data && _ctx.currentUser.user.disable_data.tariff)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("span", _hoisted_75, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin010.svg" })
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_VueNumberAnimation, {
                                  ref: "days_counter",
                                  startAmount: 0,
                                  endAmount: _ctx.currentUser.user.disable_data.tariff.fee,
                                  duration: 3,
                                  suffix: " грн",
                                  separator: ",",
                                  decimalSeparator: ".",
                                  decimals: 0,
                                  autoinit: true
                                }, null, 8, ["endAmount"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_77, " тариф: " + _toDisplayString(_ctx.currentUser.user.disable_data.tariff.description), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_78,
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                (_ctx.currentUser.user.disable_data)
                  ? (_openBlock(), _createBlock(_component_ExclamationNotice, {
                      key: 0,
                      header: "Підключення облікового запису",
                      msg: `
                        Обліковий запис вимкнено - <strong>${_ctx.currentUser.user.disable_data.date}.</strong><br/>
                        Баланс при вимкненні облікового запису - <strong>${_ctx.currentUser.user.disable_data.cash}</strong> грн.<br/>
                        Тариф при вимкненні облікового запису - <strong>${_ctx.currentUser.user.disable_data.tariff.description}.</strong><br/>
                        Для активації послуги необхідно натиснути <strong>Підключити.</strong>`,
                      margin: "mb-6"
                    }, null, 8, ["msg"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-success fw-bold min-w-85 align-self-center",
                  disabled: _ctx.in_progress,
                  "data-kt-indicator": _ctx.in_progress ? 'on' : 'off',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEnableAccount()))
                }, _hoisted_84, 8, _hoisted_81)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}